import { FC, useState } from 'react';
import { JobStatus } from '../constant';
import { getJobStatusColor, getJobStatusText } from '../utils';
import { CustomButton, CustomTextArea } from 'components';
import CustomModal from 'components/custom-modal/CustomModal';
import { useEditJobStatusMutation } from '../api';
import { API_RESPONSES } from 'types/baseTypes';
import { CircleCloseIcon, EditIconBlue } from 'assets/icons';
import { ButtonType } from 'components/custom-button/CustomButton';

interface EditStatusDetailModalProps {
  status: JobStatus;
  onBackClick: () => void;
  onSave: (jobStatus: JobStatus) => void;
  jobId: string;
  teamId: number;
  jobNumber: string;
  isRootState?: boolean;
  onClose?: () => void;
}

const EditStatusDetailModal: FC<EditStatusDetailModalProps> = ({
  status,
  onBackClick,
  onSave,
  jobId,
  teamId,
  jobNumber,
  isRootState = false,
  onClose
}) => {
  const [statusNote, setStatusNote] = useState('');
  const [editJobStatusMutation] = useEditJobStatusMutation();

  const onSaveClick = () => {
    editJobStatusMutation({
      status,
      note: statusNote.trim(),
      jobId,
      teamId
    }).then(response => {
      if ('data' in response && response.data.data.message === API_RESPONSES.SUCCESS) {
        onSave(status);
      }
    });
  };

  return (
    <CustomModal open={true} closeModal={onClose} width="md:w-[510px]">
      <div className="h-full px-[30px] py-6">
        <div className="relative flex items-center">
          <div className="flex flex-col text-headingGray">
            <span className="text-17px font-bold">Edit job status</span>
            <span className="mt-1 text-sbase font-semibold">{jobNumber}</span>
          </div>
          <CircleCloseIcon className="absolute right-0 top-0 cursor-pointer" onClick={onClose} />
        </div>
        <div className="my-6">
          <div className="mt-6">
            <div className="mb-2 text-sbase font-bold text-primaryText">Status</div>
            <div className="flex items-center justify-between rounded-md border border-borderGray p-4">
              <div className="flex items-center gap-x-2">
                <div className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: getJobStatusColor(status) }} />
                <div className="text-sbase" style={{ color: getJobStatusColor(status) }}>
                  {getJobStatusText(status)}
                </div>
              </div>
              {!isRootState && (
                <EditIconBlue className="h-[18px] w-[18px] shrink-0 cursor-pointer" onClick={onBackClick} />
              )}
            </div>
          </div>
          <div className="mt-5">
            <div className="mb-2 text-sbase font-bold text-primaryText">Add note</div>
            <CustomTextArea
              id="edit-status-note"
              name="edit-status-note"
              className="h-[140px] max-h-[140px] rounded-md border border-borderGray bg-transparent font-medium
               text-accentText focus:outline-none"
              value={statusNote}
              onChange={setStatusNote}
            />
          </div>
        </div>
        <div className="flex w-full justify-end gap-x-4">
          <CustomButton
            type={ButtonType.SECONDARY}
            id="edit-status-cancel-button"
            className="w-[100px]"
            onClick={onClose ? onClose : onBackClick}>
            Cancel
          </CustomButton>
          <CustomButton id="edit-status-save-button" className="w-[100px]" onClick={onSaveClick}>
            Save
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default EditStatusDetailModal;
